export const messages = {
  ru: {
    message: {
      grid: {
        loadingOoo: 'Загрузка...',
        noRowsToShow: 'Нет данных для показа',
        of: 'из',
        page: 'Страница',
        to: ' - ',

        // for number filter and text filter
        filterOoo: 'Фильтр...',
        applyFilter: 'Применить фильтр',
        equals: 'Равно',
        notEquals: 'Не равно',

        // for number filter
        lessThan: 'Меньше чем',
        greaterThan: 'Больше чем',
        lessThanOrEqual: 'Меньше или равно',
        greaterThanOrEqual: 'Больше или равно',
        inRange: 'В диапазоне',

        // for text filter
        contains: 'Содержит',
        notContains: 'Не содержит',
        startsWith: 'Начинается с',
        endsWith: 'Заканчивается',

        // filter conditions
        andCondition: 'И',
        orCondition: 'ИЛИ',

        block: 'Блок компетенций',
        created_date: 'Дата оценки',
        departments: 'Отделы',
        updated_date: 'Дата обновления',
        details: 'Подробнее',
        graded: 'Кого оценили',
        grading: 'Кто оценил',
        id: 'Номер ',
        heads: 'Руководители',
        open: 'Открыть',
        percent: 'Коллеги и подчинённые',
        position: 'Должность',
        positions: 'Должности',

        report_id: 'Номер отчёта',
        role: 'Роль',
        self_rate: 'Самооценка',
        show: 'Просмотр',
        sort: 'Сортировка',
        status: 'Статус',
        title: 'Название',
        user: 'Сотрудник',
        value: 'Общая оценка',
        weight: 'Вес',
      },
    },
  },
  en: {
    message: {
      grid: {
        loadingOoo: 'Loading...',
        noRowsToShow: 'No data to show',
        of: 'of',
        page: 'Page',
        to: 'to',

        // for number filter and text filter
        filterOoo: 'Filter...',
        applyFilter: 'Apply Filter...',
        equals: 'Equals',
        notEquals: 'Not Equal',

        // for number filter
        lessThan: 'Less Than',
        greaterThan: 'Greater Than',
        lessThanOrEqual: 'Less Than Or Equal',
        greaterThanOrEqual: 'Greater Than Or Equal',
        inRange: 'In Range',

        // for text filter
        contains: 'Contains',
        notContains: 'Not Contains',
        startsWith: 'Starts with',
        endsWith: 'Ends with',

        // filter conditions
        andCondition: 'AND',
        orCondition: 'OR',

        block: 'Block',
        created_date: 'Creation date',
        departments: 'Departments',
        updated_date: 'Update date',
        details: 'Details',
        graded: 'Employee for whom the rating is filled',
        grading: 'The employee who fills the rating',
        heads: 'Heads',
        id: 'ID',
        open: 'Open',
        percent: 'Colleagues and subordinates',
        position: 'Position',
        positions: 'Positions',
        report_id: 'Report ID',
        role: 'Role',
        self_rate: 'Self rate',
        show: 'Details',
        sort: 'Sorting',
        status: 'Status',
        title: 'Title',
        user: 'Employee',
        value: 'Overall grade',
        weight: 'Weight',
      },
    },
  },
  de: {
    message: {
      grid: {
        loadingOoo: 'Loading...',
        noRowsToShow: 'No data to show',
        of: 'of',
        page: 'Page',
        to: 'to',

        // for number filter and text filter
        filterOoo: 'Filter...',
        applyFilter: 'Apply Filter...',
        equals: 'Equals',
        notEquals: 'Not Equal',

        // for number filter
        lessThan: 'Less Than',
        greaterThan: 'Greater Than',
        lessThanOrEqual: 'Less Than Or Equal',
        greaterThanOrEqual: 'Greater Than Or Equal',
        inRange: 'In Range',

        // for text filter
        contains: 'Contains',
        notContains: 'Not Contains',
        startsWith: 'Starts with',
        endsWith: 'Ends with',

        // filter conditions
        andCondition: 'AND',
        orCondition: 'OR',

        block: 'Block',
        created_date: 'Creation date',
        departments: 'Departments',
        updated_date: 'Update date',
        details: 'Details',
        graded: 'Employee for whom the rating is filled',
        grading: 'The employee who fills the rating',
        heads: 'Heads',
        id: 'ID',
        open: 'Open',
        percent: 'Colleagues and subordinates',
        position: 'Position',
        positions: 'Positions',
        report_id: 'Report ID',
        role: 'Role',
        self_rate: 'Self rate',
        show: 'Details',
        sort: 'Sorting',
        status: 'Status',
        title: 'Title',
        user: 'Employee',
        value: 'Overall grade',
        weight: 'Weight',
      },
    },
  },

};
